<template>
	<div>
		<TableList :form_data_seo.sync="form_data_seo" :columns="columns" :get_table_list="this.get_table_list"
			:slot_table_list="['operation','status','goods','goods_put']" @changeStatus='changeStatus'
			:submit_preprocessing="submit_preprocessing" ref="list">
			<template slot="form_after">
				<div class='page_content_top page_content'>
					<div v-for='item in tracing_count'>
						<a-statistic :title="item.label" :value="item.value" />
					</div>
				</div>

			</template>
			<template slot="left_btn">
				<a-button class="float_left" v-auth="'change'" @click="add()" type="primary">添加产线</a-button>
			</template>
			
		

			<template slot="operation" slot-scope="data">
				
				<span>
					<a v-auth="'change'" @click="edit(data.record)">编辑</a>
				</span>
				<a-divider type="vertical" />
				<span>
					<a v-auth="'change'" @click="changeStatusFun(data.record)">{{data.record.status==1?'禁用':'启用'}}</a>
				</span>
				<a-divider type="vertical" v-auth="'delete'" />
				<span>
					<a-popconfirm title="您确定要删除吗?" v-auth="'delete'" @confirm="del(data.record)">
						<a>删除</a>
					</a-popconfirm>
				</span>
					
					
			</template>
			<template slot="goods_put" slot-scope="data">
				<span v-if="data.text=='1'">是</span>
				<span v-else-if="data.text=='0'">否</span>
			</template>

		</TableList>


		<EditPop @handleSubmit="submit" :form_data="form_data" :visible.sync="visible">

		</EditPop>
	</div>
</template>

<script>
	// @ is an alias to /src
	import EditPop from "@/components/EditPop";
	import Form from "@/components/Form";
	import TableList from "@/components/TableList";
	import codeList from "@/components/codeList";
	import QRCode from 'qrcodejs2'

	import {
		saveLine,
		getLineList,
		getWarehouseSelect,
		getLinseSelect,
		getStatusSelect,
		save,
		changeLineStatus,
		getLineTopCount,getFactorySelect,
		deleteMachine
	} from "@/api/traceability";

	let columns = [{
			title: "编号",
			dataIndex: "id",
		},

		{
			title: "产线名称",
			dataIndex: "name",
		},
		{
			title: "基地",
			dataIndex: "warehouse_name",
		},
		{
			title: "基地地址",
			dataIndex: "address",
		},

		{
			title: "添加时间",
			dataIndex: "create_time",

		},
		{
			title: "产线状态",
			dataIndex: "status_name",
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			}
		},
	];

	export default {
		name: "gpoodIndex",
		components: {
			EditPop,
			Form,
			codeList,
			TableList,
		},
		data() {
			return {
				tracing_count: [],
				list_visible: false,
				get_table_list: getLineList,
				form: this.$form.createForm(this, {
					name: "advanced_search"
				}),
				columns,
				visible: false,
				form_data: {
					title: '添加',
					list: [{
							type: 'text',
							name: 'id',
							hidden: true,
							options: {},
						},
						{
							type: 'text',
							name: 'name',
							title: '产线名称',
							options: {
								rules: [{
									required: true,
									message: "请输入产线名称"
								}]
							},
						},

						{
							type: "select",
							name: "factory_sap_id",
							title: "基地",
							options: {

							},
							treeData: [],
							multiple: true
						},


					]
				},
				form_data_seo: {
					list: [
						{
							type: "text",
							name: "name",
							title: "产线名称",
							placeholder: '产线名称',
							options: {

							}
						},
						{
							type: "text",
							name: "factory_name",
							title: "基地名称",
							placeholder: '基地名称',
							options: {

							}
						},
						{
							type: 'select',
							name: 'status',
							title: '状态',
							list: [],
							options: {},
						},
					],
					...this.$config.form_data_seo
				},
				submit_preprocessing: {
					array_to_string: ['cate_id', 'department_ids', 'department_ids2']
				}
			};
		},
		async created() {
			this.get_option()
			this.get_Tracing_Count({})

		},
		methods: {
			
			changeStatus(data){
				this.get_Tracing_Count(data)
			},
			get_Tracing_Count(data) {
				getLineTopCount({data:{...data}}).then(res => {
					this.tracing_count = res.data.list
				})
			},
			edit(data) {
				this.form_data.list.forEach(item => {

					if (item.name == 'name') {
						item.options.initialValue = data.name;
					}
					if (item.name == 'factory_sap_id') {
						item.options.initialValue = data.factory_sap_id;
					}
					if (item.name == 'line_id') {
						item.options.initialValue = data.line_id;
					}
					if (item.name == 'id') {
						item.options.initialValue = data.id;
					}
				})

				this.form_data.title = "编辑产线"
				this.visible = true;

			},
			del(data) {
				// 删除
				deleteMachine({
					data: {
						id: data.id
					},
					info: true,
				}).then(res => {
					this.$refs.list.get_list();
				})
			},
			// 
			changeStatusFun(data) {
				// 修改状态
				changeLineStatus({
					data: {
						id: data.id
					},
					info: true,
				}).then(res => {
					this.$refs.list.get_list();
				})
			},
			get_option() {
				// 仓库数据
				getFactorySelect().then(res => {
					this.$method.set_form_list(this.form_data.list, 'factory_sap_id', 'list', res.data.list);
				})

				// 状态数据
				getStatusSelect().then(res => {
					this.$method.set_form_list(this.form_data_seo.list, 'status', 'list', res.data.list);
				})
			},
			add() {
				this.form_data.title = "添加产线"
				this.visible = true;
			},
			submit(e) {
				let data = e.values;

				saveLine({
					data: {
						...data
					},
					info: true,
				}).then(res => {
					this.visible = false;
					this.$refs.list.get_list();
				})
			},

		}
	};
</script>

<style lang="less">
	@import url("../../../assets/less/app.less");

	.max_price_tips {
		margin-left: 99px;
		margin-top: -30px;
		font-size: 13px;
	}

	.float_left {
		margin-right: 8px;
	}

	.max_price_form {
		.item {
			display: flex;

			.right {
				flex: 1;

				.input_number {
					width: 100%;
				}
			}
		}
	}

	.qrCodeUrlImg {
		margin-left: 110px;
	}

	.page_content_top {
		display: flex;

		div {
			flex: 1;
			text-align: center;
		}
	}
</style>